import { render, staticRenderFns } from "./billPay.vue?vue&type=template&id=6f970b48&"
import script from "./billPay.vue?vue&type=script&lang=js&"
export * from "./billPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports